import {InputOrTextArea, InputProps} from '@local/ui/components'
import {forwardRef} from 'react'

export const Input = forwardRef<HTMLDivElement, InputProps>(({...props}: InputProps, ref) => {
	return <InputOrTextArea as='input' ref={ref} {...props} />
})
